import { createFileRoute } from '@tanstack/react-router'
import PropertiesPageClient from '#/components/properties/PropertiesPageClient'

export const Route = createFileRoute('/_authenticated/$slug/settings/properties')({
  component: PropertiesPageClient,
})
